export default __webpack_public_path__ + "static/media/lager_822_info_2.514a9085.png";